import { render } from "./lines_right_blur.svg?vue&type=template&id=401e859e"
const script = {}
script.render = render

export default script